/* @flow */
import Button from 'components/Button.jsx';
import CurrentUser from 'auth/CurrentUser';
import ActivityRecipient, { RECIPIENT_ATTENDING, RECIPIENT_MAYBE, RECIPIENT_DECLINED } from 'entities/ActivityRecipient';
import EventTrackingConstants from 'payments/constants/EventTrackingConstants';
import trackView from 'lib/trackView';
import Activity from 'entities/Activity';
import React from 'react';
import Text from 'components/Text.jsx';
import TitleHeader from 'components/TitleHeader.jsx';
import Transaction from 'entities/Transaction';
import TransactionActions from 'payments/actions/TransactionActions';
import withoutPaymentHeader from 'payments/utils/withoutPaymentHeader';
import isEmail from 'lib/isEmail';
import isPhone from 'lib/isPhone';
import Link from 'components/Link.jsx';
import { buildGoogleCalendarUrl } from 'lib/createGoogleCalLink';
import PaymentViewConfirmationEmailAuthentificator from './PaymentViewConfirmationEmailAuthentificator.jsx';
import PaymentViewConfirmationPhoneAuthentificator from './PaymentViewConfirmationPhoneAuthentificator.jsx';
import GoogleSignIn from 'auth/components/GoogleSignIn.jsx';
import DividerText from 'components/DividerText.jsx';
import ToastActions from 'actions/ToastActions';

import './styles/PaymentViewConfirmation.scss';

const PaymentViewConfirmation = React.createClass({
  propTypes: {
    transaction: React.PropTypes.instanceOf(Transaction),
    activity: React.PropTypes.instanceOf(Activity).isRequired,
    recipient: React.PropTypes.instanceOf(ActivityRecipient).isRequired,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
    isModal: React.PropTypes.bool.isRequired,
    onRequestHide: React.PropTypes.func,
  },

  getInitialState() {
    return {
      submittedPassword: false,
      loading: false,
    };
  },

  onAuthSuccess() {
    let promise;

    // If there's a transaction (paid activity) then claim the
    // transaction and the recipient thought it, otherwise just
    // claim the recipient.
    if (this.props.transaction) {
      promise = TransactionActions.claim(this.props.transaction, {
        recipient_uuid: this.props.recipient.id,
      });
    } else {
      promise = this.props.recipient.claim(this.props.activity);
    }

    promise
      .then(() => this.setState({ submittedPassword: true }))
      .catch((err) => {
        ToastActions.showAPIError(err);
        console.log(err); // track in trackjs
      });
  },

  getEventAuthStatus() {
    let authStatus;

    if (CurrentUser.isSignedIn()) {
      authStatus = 'logged_in_user';
    } else {
      authStatus = this.props.recipient.getUserUuid() ? 'unauthed_user' : 'new_user';
    }

    return authStatus;
  },

  renderAuthenticationForm() {
    let authentificator;

    if (isPhone(this.props.recipient.getAddress())) {
      authentificator = (
        <PaymentViewConfirmationPhoneAuthentificator
          recipient={this.props.recipient}
          onAuthSuccess={this.onAuthSuccess}
        />
      );
    }

    if (isEmail(this.props.recipient.getAddress())) {
      authentificator = (
        <PaymentViewConfirmationEmailAuthentificator
          recipient={this.props.recipient}
          onAuthSuccess={this.onAuthSuccess}
          authStatus={this.getEventAuthStatus()}
        />
      );
    }

    return (
      <div>
        {authentificator}
        <DividerText text="or" uppercase className="PaymentViewConfirmation-divider" />
        <GoogleSignIn onSuccess={this.onAuthSuccess} />
      </div>
    );
  },

  renderConfirmationButtons() {
    const chatUuid = this.props.activity.getChatUuid();

    const href = chatUuid ?
      `/chat/${chatUuid}` :
      '/classes';

    let props = {};

    if (this.context.isModal && this.context.onRequestHide) {
      props = {
        onClick: this.context.onRequestHide,
        children: 'Close',
      };
    } else {
      /* href, full page reload
       * to have mobile clients able
       * to respond to the url change.
       */
      props = {
        href,
        children: chatUuid ? 'Join conversation' : 'Go to Remind',
      };
    }

    return (
      <Button
        level="primary"
        {...props}
        className="PaymentViewConfirmation-button"
        eventScreenName={EventTrackingConstants.PAYMENT_RECEIPT}
        eventElementName="back_to_remind"
      />
    );
  },

  renderGoogleCalUrl() {
    const { activity } = this.props;
    const date = activity.getStartAt();
    const title = activity.getTitle();
    const welcomeMsgBody = activity.getWelcomeMsgBody();
    const location = activity.getLocation();
    const googleCalendarUrl = date ? buildGoogleCalendarUrl(title, date, welcomeMsgBody, location) : null;

    return googleCalendarUrl ? (
      <div className="PaymentViewConfirmation-link">
        <Link target="_blank" href={googleCalendarUrl}>
          <Text size="xsmall">
            Add to Google Calendar
          </Text>
        </Link>
      </div>
    ) : <span />;
  },

  render() {
    const content = CurrentUser.isSignedIn() || this.state.submittedPassword ?
      this.renderConfirmationButtons() :
      this.renderAuthenticationForm();

    let attendanceText;

    if (this.props.recipient.getAttendance() === RECIPIENT_ATTENDING) {
      attendanceText = 'You’ve responded Yes!';
    } else if (this.props.recipient.getAttendance() === RECIPIENT_MAYBE) {
      attendanceText = 'You’ve responded Maybe';
    } else if (this.props.recipient.getAttendance() === RECIPIENT_DECLINED) {
      attendanceText = 'You’ve responded No';
    }

    const name = this.props.activity.getRequester().getDisplayName();
    const subtext = (
      <Text size="xsmall">
        Your response has been sent to {name}.
        If you need to change your response, you can always update
        this page.
      </Text>
    );
    return (
      <div className="PaymentViewConfirmation" data-test-selector="payment_view_confirmation">
        <TitleHeader
          title={attendanceText}
          subtext={subtext}
          bottomMargin="none"
          textAlign="center"
          size="xlarge"
        />
        {this.renderGoogleCalUrl()}
        <div className="PaymentViewConfirmation-separator" />
        {content}
      </div>
    );
  },
});

export default trackView(withoutPaymentHeader(PaymentViewConfirmation), EventTrackingConstants.PAYMENT_RECEIPT);



// WEBPACK FOOTER //
// ./src/payments/components/PaymentViewConfirmation.jsx